import React, {useState} from 'react';
import s from "../Security.module.css";
import {motion} from "framer-motion";
import {useAppDispatch, useAppSelector} from "../../../../hooks/redux";
import {
    sendEmailOnLoginHandleChangeThunk,
    setIsLogOutWhenIpWasChangedThunk,
    setIsLogOutWhenUserWasInactiveThunk, setSaveLoginHistoryThunk
} from "../../../../store/reducers/ActionCreators";
import HistoryTable from "../../../../components/HistoryTable/HistoryTable";
import CustomizedSwitch from "../../../../components/ui/CustomizedSwitch/CustomizedSwitch";

type propsType = {
    isMobile: boolean
}

const Session = (props: propsType) => {

    const dispatch = useAppDispatch()
    const isLogOutWhenUserWasInactive: boolean | undefined = useAppSelector(state => state.userReducer.user.flags.autoLogout)
    const isLogOutWhenIpWasChanged: boolean | undefined = useAppSelector(state => state.userReducer.user.flags.logoutIfIpChanges)
    const isSendEmailOnLogin: boolean | undefined = useAppSelector(state => state.userReducer.user.flags.sendEmailOnLogin)
    const isSaveLoginHistory: boolean | undefined = useAppSelector(state => state.userReducer.user.flags.saveLoginHistory)
    const token = useAppSelector(state => state.userReducer.userToken)
    const accountId = useAppSelector(state => state.userReducer.chosenAccountTypeId)
    const loginHistory = useAppSelector(state => state.userReducer.loginHistory)

    const [isHistoryShow, setIsHistoryShow] = useState(false)

    const leaveTheSessionOpenHandleChange = (payload: boolean) => {
        dispatch(setIsLogOutWhenUserWasInactiveThunk(token, payload, accountId))
    }

    const isLogOutWhenIpWasChangedHandleChange = (payload: boolean) => {
        dispatch(setIsLogOutWhenIpWasChangedThunk(token, payload, accountId))
    }

    const sendEmailOnLoginHandleChange = (payload: boolean) => {
        dispatch(sendEmailOnLoginHandleChangeThunk(token, payload, accountId))
    }

    const setSaveLoginHistoryHandleChange = (payload: boolean) => {
        dispatch(setSaveLoginHistoryThunk(token, payload, accountId))
    }

    return (
        <motion.div
            initial={{opacity: 0, scale: 1}}
            animate={{opacity: 1, scale: 1}}
            transition={{duration: 0.5}}
        >
            {
                isHistoryShow
                    ? <HistoryTable
                        loginHistory={loginHistory}
                        setIsHistoryShow={setIsHistoryShow}
                        isMobile={props.isMobile}
                    />
                    : <div>
                        <div className={s.autentication_list_block}>
                            <div className={s.autentication_item}>
                                <div className={s.row}>
                                    <span className={s.autentication_title}>Leave the session open</span>
                                    <CustomizedSwitch
                                        checked={!isLogOutWhenUserWasInactive}
                                        isMobile={props.isMobile}
                                        onHandleChange={(checked) => leaveTheSessionOpenHandleChange(!checked)}
                                    />
                                </div>
                                <div className={s.autentication_item_description}>
                                If you are logged in but not active, the session will be prevented from being closed.
                                If this feature is disabled, the session will be closed after 10 minutes of inactivity.
                                </div>
                            </div>

                            <div className={s.autentication_item}>
                                <div className={s.row}>
                                    <span className={s.autentication_title}>Send email on login</span>
                                    <CustomizedSwitch
                                        checked={isSendEmailOnLogin}
                                        isMobile={props.isMobile}
                                        onHandleChange={(checked) => sendEmailOnLoginHandleChange(checked)}
                                    />
                                </div>
                                <div className={s.autentication_item_description}>
                                    Each time you log into your account, you will receive an email with information about
                                    the IP address of the authorized use.
                                </div>
                            </div>

                            <div className={s.autentication_item}>
                                <div className={s.row}>
                                    <span className={s.autentication_title}>Log out when my IP address changes</span>
                                    <CustomizedSwitch
                                        checked={isLogOutWhenIpWasChanged}
                                        isMobile={props.isMobile}
                                        onHandleChange={(checked) => isLogOutWhenIpWasChangedHandleChange(checked)}
                                    />
                                </div>
                                <div className={s.autentication_item_description}>
                                    Check the box if you want the session to be closed when the IP address changes (for
                                    example,
                                    when your mobile device switches from Wi-Fi to LTE).
                                </div>
                            </div>

                            <div className={s.autentication_item}>
                                <div className={s.row}>
                                    <span className={s.autentication_title}>Login history</span>
                                    <CustomizedSwitch
                                        checked={isSaveLoginHistory}
                                        isMobile={props.isMobile}
                                        onHandleChange={(checked) => setSaveLoginHistoryHandleChange(checked)}
                                    />
                                </div>
                                <div className={s.autentication_item_description}>
                                    Every account login is logged and &nbsp;
                                    <span
                                       onClick={() => setIsHistoryShow(true)}
                                       className={s.login_history_link}
                                    >
                                        available here
                                    </span>
                                </div>
                            </div>

                            {/*<div className={s.buttons_block_end}>*/}
                            {/*    <div className={s.button_wrapper}>*/}
                            {/*        <MyBtn title={"Save"} isPersonalAccountBtn large/>*/}
                            {/*    </div>*/}
                            {/*</div>*/}

                        </div>
                    </div>
            }

        </motion.div>
    );
};

export default Session;
